import React from 'react';

import { PushPage } from 'pages';
import { NOTI_MENU_URL } from 'data/menu';

const PUSH_URL = NOTI_MENU_URL['앱 푸시 관리'];

const pushApp = [
  {
    path: PUSH_URL,
    element: <PushPage.List />,
  },
  {
    path: `${PUSH_URL}/register`,
    element: <PushPage.Register />,
  },
  {
    path: `${PUSH_URL}/:id`,
    element: <PushPage.Detail />,
  },
  {
    path: `${PUSH_URL}/:id/edit`,
    element: <PushPage.Register />,
  },
];

export { pushApp };
